<template>
  <van-tabbar @click="onClick" v-model="active" active-color="#DD2B1E" inactive-color="#999" fixed>
    <van-tabbar-item
      @click="urlFn(item.url)"
      :class="item.tag === '招募' ? 'centerZ':''"
      v-for="item in icon"
      :key="item.tag"
    >
      <span>{{ item.tag }}</span>
      <template #icon="props">
        <img :src="props.active ? item.active : item.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  <!-- <div class="bottomBar">
    <div>按钮1</div>
    <div>按钮2</div>
  </div> -->
</template>

<script>
export default {
  name: "footerBody",
  data() {
    return {
      active: 0,
      activeCopy: 0,
      icon: [
        {
          tag: "商品",
          active: require("./images/1x.png"),
          inactive: require("./images/1.png"),
          url: "/distribution/goodsHome"
        },
        {
          tag: "团队",
          active: require("./images/2x.png"),
          inactive: require("./images/2.png"),
          url: "/distribution/teamHome"
        },
        {
          tag: "招募",
          active: require("./images/3.png"),
          inactive: require("./images/3.png"),
          url: "/distribution/recruitHome"
        },
        {
          tag: "订单",
          active: require("./images/4x.png"),
          inactive: require("./images/4.png"),
          url: "/distribution/orderHome"
        },
        {
          tag: "收益",
          active: require("./images/5x.png"),
          inactive: require("./images/5.png"),
          url: "/distribution/shortHome"
        }
      ]
    };
  },
  computed: {},
  filters: {},
  created() {
    let path = this.$route.path;
    switch (path) {
      case "/goodsHome":
        this.active = 0;
        break;
      case "/teamHome":
        this.active = 1;
        break;
      case "/recruitHome":
        this.active = 2;
        break;
      case "/orderHome":
        this.active = 3;
        break;
      case "/shortHome":
        this.active = 4;
        break;
      default:
        this.active = 0;
    }
  },
  methods: {
    urlFn(url) {
      let path = this.$route.path;
      if ("/distribution" + path !== url) {
        window.location.href = url;
        // this.$router.push({path: url})
      }
    },
    onClick(name, title) {
      if (name !== this.activeCopy) {
        this.activeCopy = this.name;
      }
    }
  }
};
</script>

<style scoped>
/* .bottomBar {
  display: flex;
  padding: 20px;
  justify-content: space-around;
  position: fixed;
  bottom: 0px;
  background: #fff;
  width: 100%;
  align-items: center;
} */
/deep/ .centerZ {
  /*display: inline-block;*/
  position: relative;
}

/deep/ .van-tabbar-item__icon img {
  width: 22px;
  height: 22px;
}

/deep/ .centerZ .van-tabbar-item__icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  position: absolute;
  top: -28px;
  margin-bottom: 0;
}

/deep/ .centerZ .van-tabbar-item__icon img {
  width: 100%;
  height: 100%;
}

/deep/ .centerZ .van-tabbar-item__text {
  margin-top: 27px;
}
/deep/ .van-tabbar--fixed {
  bottom: 0;
  bottom: constant(safe-area-inset-bottom);
  bottom: env(safe-area-inset-bottom);
}
</style>
